import type { BoxProps } from '@chakra-ui/react';
import type { ProductBlock } from 'types/cms/blocks/ProductBlock';
import type { ProductBundle } from 'types/cms/blocks/ProductBundle';
import type { SignupBanner } from 'types/cms/blocks/SignupBanner';
import type { SkincareFormatPicker } from 'types/cms/blocks/SkincareFormatPicker';
import type { SupplementPicker } from 'types/cms/blocks/SupplementPicker';

import { ProductBundleCtas } from './ProductBundleCtas';
import { ProductCtas } from './ProductCtas';
import { SignupBannerCtas } from './SignupBannerCtas';
import { mapProductBlockToCtas } from './utils/mapProductBlockToCtas';
import { mapSkincareFormatPickerToCtas } from './utils/mapSkincareFormatPickerToCtas';
import { mapSupplementPickerToCtas } from './utils/mapSupplementPickerToCtas';

export type AnchorBlock =
  | ProductBlock
  | SupplementPicker
  | SkincareFormatPicker
  | ProductBundle
  | SignupBanner;

interface AnchorCtasProps extends BoxProps {
  colorScheme: 'white' | 'gray';
  anchorBlock?: AnchorBlock;
}

export function AnchorCtas({ anchorBlock, ...props }: AnchorCtasProps) {
  switch (anchorBlock?._type) {
    case 'timeline_productBlock':
      return <ProductCtas {...mapProductBlockToCtas(anchorBlock)} {...props} />;
    case 'timeline_supplementPicker':
      return (
        <ProductCtas {...mapSupplementPickerToCtas(anchorBlock)} {...props} />
      );
    case 'timeline_skincareFormatPicker':
      return anchorBlock.productFormats.length > 0 ? (
        <ProductCtas
          {...mapSkincareFormatPickerToCtas(anchorBlock)}
          {...props}
        />
      ) : null;
    case 'productBundle':
      return <ProductBundleCtas productBundle={anchorBlock} {...props} />;
    case 'timeline_signupBanner':
      return <SignupBannerCtas signupBanner={anchorBlock} {...props} />;
    default:
      return null;
  }
}
